import { useStore, useStoreMap } from 'effector-react'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { aggregatorAccountModel } from '~/entities/common/Taxipark/AggregatorAccount'
import {
  EditAggregatorAccount,
  editAggregatorAccountModel,
} from '~/features/common/Taxipark/AggregatorAccount/EditAggregatorAccount'
import { Breadcrumbs, BreadcrumbsList } from '~/shared/ui/Breadcrumbs'
import { Container, PageContainer, PageTitle } from '~/shared/ui/Layout'
import { NotFound } from '~/shared/ui/NotFound'

export const EditAggregatorAccountPage = () => {
  const { t } = useTranslation()
  const { aggregatorAccountId } = useParams<{ aggregatorAccountId: string }>()

  const isLoading = useStore(aggregatorAccountModel.requestFx.pending)
  const name = useStoreMap(
    editAggregatorAccountModel.$aggregatorAccount,
    (aggregatorAccount) => aggregatorAccount?.getTitle(),
  )

  const breadcrumbs: BreadcrumbsList = useMemo(
    () => [
      {
        titleI18n: 'aggregator accounts',
        link: '/taxipark/aggregator-accounts',
      },
      { title: name || '' },
    ],
    [name],
  )

  const error = aggregatorAccountModel.useAggregatorAccountError(
    aggregatorAccountId as string,
  )

  if (!aggregatorAccountId || error) {
    return <NotFound message={t('alert.failed to load aggregator data')} />
  }

  return (
    <PageContainer title={t('aggregator account card')}>
      <Container isHeader>
        <Breadcrumbs list={breadcrumbs} lastLoading={isLoading} />
        <PageTitle loading={isLoading}>{name}</PageTitle>
      </Container>

      <EditAggregatorAccount aggregatorAccountId={aggregatorAccountId} />
    </PageContainer>
  )
}
